import React, { useEffect, useState } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { RecordDataIndicators } from '../../components/RecordDataIndicators';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { isRecordFound, useSelectedOrganizationData } from '../../hooks/data-hooks';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { AppRoute, AppRoutes } from '../../routes';
import { PxDeviceProfileData } from '../../components/DeviceProfile/PxDeviceProfileData';
import { useDeviceDetails } from '../../data/DataProviders/DeviceDetailsProvider';
import { DevicePropertiesDetails} from '../../types/device';
import { isDataLoaded } from '../../types';
import { DataIndicators } from '../../components/DataIndicators';
import { GenericToolbar } from '../../components/GenericToolbar';
import { pushAppRoute } from '../../data/domain/route-manager';
import { SignalRSiteDataProvider } from '../../data/DataProviders/SignalRSiteDataProvider';
//import { EditStarfishConnectedDevice } from './EditStarfishConnectedDevice';


export const PxDeviceProfile: React.FC = () => {
    const selectedOrganization = useSelectedOrganizationData();
    const currentAppRoute = useCurrentAppRoute();
    const history = useHistory();
    const { t } = useLanguageLocale();
    const pxdbDeviceDetails = useDeviceDetails();
    //const starfishDeviceDetails = useStarfishDeviceDetails();
    const currentPage = currentAppRoute.type === 'PxDeviceProfile' ? 'PxDeviceProfile' : '';
    const gatewayName = isDataLoaded(pxdbDeviceDetails) ? pxdbDeviceDetails.value.name : '';
    //const starfishGatewayName = isDataLoaded(starfishDeviceDetails) ? starfishDeviceDetails.value.name : '';
    const [gatewayDeviceData, setGatewayDeviceData] = useState<DevicePropertiesDetails | null>(null);
   // const [starfishGatewayDeviceData, setStarfishGatewayDeviceData] = useState<StarfishDeviceData | null>(null);
    const [childDeviceList, setchildDeviceList] = useState<any[]>([]);
    // const updateGatewayDeviceData = (modifiedData: DevicePropertiesDetails): void => {
    //     if (isDataLoaded(pxdbDeviceDetails)) {
    //         const data = { ...pxdbDeviceDetails.value };
    //         data.serialNumber = modifiedData.serialNumber;
    //         data.name = modifiedData.name;
    //         //data.configTreeJson = modifiedData.configTreeJson;
    //         setGatewayDeviceData(data);
    //     }
    // };

    useEffect(() => {
        if (isDataLoaded(pxdbDeviceDetails)) {
            setGatewayDeviceData(pxdbDeviceDetails.value);

            if (pxdbDeviceDetails.value.devices) {

                setchildDeviceList(pxdbDeviceDetails.value.devices);
            }
        }
    }, [pxdbDeviceDetails]);
    // useEffect(() => {
    //     if (isDataLoaded(starfishDeviceDetails)) {
    //         setStarfishGatewayDeviceData(starfishDeviceDetails.value);

    //         if (starfishDeviceDetails.value.ChildDevices) {

    //             setchildDeviceList(starfishDeviceDetails.value.ChildDevices);
    //         }
    //     }

    // }, [starfishDeviceDetails]);

    const backRoute = (orgId: string, locationId: string, siteId: string, deviceId: string): AppRoute =>
        currentPage === 'PxDeviceProfile'
            ? { type: 'SiteProfile', orgId: orgId, locationId: locationId, siteId: siteId }
            : {
                type: 'PxDeviceProfile',
                deviceId: deviceId,
                locationId: locationId,
                orgId: orgId,
                siteId: siteId,
            };

    return (
        <>
            <RecordDataIndicators
                recordData={selectedOrganization}
                errorMessage={t('DASHBOARD.ERROR_LOADING_ORGANIZATION')}
                notFoundIcon="Business"
                notFoundMessage={t('DASHBOARD.ORGANIZATION_NOT_FOUND')}
            />
            {isRecordFound(selectedOrganization) &&
                'locationId' in currentAppRoute &&
                'deviceId' in currentAppRoute &&
                'siteId' in currentAppRoute && (
                    <>

                        {(currentAppRoute.type === 'PxDeviceProfile') && (
                            <GenericToolbar
                                showBackButton
                                backButtonOnClick={(): void => {
                                    pushAppRoute(
                                        history,
                                        backRoute(
                                            selectedOrganization.value.id,
                                            currentAppRoute.locationId,
                                            currentAppRoute.siteId,
                                            currentAppRoute.deviceId
                                        )
                                    );
                                }}
                                title={currentPage === 'PxDeviceProfile' ? gatewayName : ''}
                                subtitle={currentPage === 'PxDeviceProfile' ? 'Connected Device Profile' : gatewayName}
                            />
                        )}

                        <DataIndicators
                            emptyIcon="Devices"
                            emptyMessage={'No Device Data'}
                            errorMessage={'No Device Data'}
                            data={pxdbDeviceDetails}
                            isEmpty={false}
                        />

                        {isDataLoaded(pxdbDeviceDetails) && (
                            <Switch>
                                <Route exact path={AppRoutes.PxDeviceProfile}>
                                    <SignalRSiteDataProvider siteId={currentAppRoute.siteId} locationId={currentAppRoute.locationId}>
                                        <PxDeviceProfileData
                                            data={gatewayDeviceData}
                                            backAppRoute={backRoute(
                                                selectedOrganization.value.id,
                                                currentAppRoute.locationId,
                                                currentAppRoute.siteId,
                                                currentAppRoute.deviceId
                                            )}
                                            childDeviceList={childDeviceList}
                                        />
                                    </SignalRSiteDataProvider>
                                </Route>

                            </Switch>
                        )}


                    </>
                )}
        </>
    );
};
